import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar.js';
import Sidebar from '../components/Sidebar.js';
import { useNavigate } from "react-router-dom";
import { Globals } from '../globalfunctions.js';
import { apiClient } from '../utils/apiClient';
import { alertDialog } from '../utils/dialogs';
import './CreateCustomer.css'; // Import the CSS file for styling

function CreateCustomer() {
  
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    address1: '',
    address2: '',
    city: '',
    county: '',
    postcode: '',
    country: '',
    email: '',
    password: '',
    phoneNumber: '',
    status: 'Active',
    notes: ''
  });

  useEffect(() => {
    if (Globals.LoginTime === null) {
      navigate('/login');
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = await apiClient.post('/api/users', {
        first_name: formData.firstName,
        last_name: formData.lastName,
        companyName: formData.companyName,
        address1: formData.address1,
        address2: formData.address2,
        city: formData.city,
        county: formData.county,
        postcode: formData.postcode,
        country: formData.country,
        email: formData.email,
        password: formData.password,
        phoneNumber: formData.phoneNumber,
        status: 'Active',
        notes: formData.notes,
        role_type: 'Customer'
      });
      console.log('Success:', data);
      alertDialog('Customer created successfully!');
      navigate('/users'); // Redirect to customers page or another appropriate page
    } catch (error) {
      console.error('Error:', error);
      alertDialog('Failed to create customer. Please try again.');
    }
  };

  return (
    <div>
      <Navbar />
      <Sidebar />
      <div className="main-content">
        <h1 className="form-title">Create Customer</h1>
        <form onSubmit={handleSubmit} className="customer-form">
          <div className="form-group">
            <label htmlFor="firstName">First Name:</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="lastName">Last Name:</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="companyName">Company Name (Optional):</label>
            <input
              type="text"
              id="companyName"
              name="companyName"
              value={formData.companyName}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="address1">Address 1:</label>
            <input
              type="text"
              id="address1"
              name="address1"
              value={formData.address1}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="address2">Address 2 (Optional):</label>
            <input
              type="text"
              id="address2"
              name="address2"
              value={formData.address2}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="city">City:</label>
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="county">County:</label>
            <input
              type="text"
              id="county"
              name="county"
              value={formData.county}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="postcode">Postcode:</label>
            <input
              type="text"
              id="postcode"
              name="postcode"
              value={formData.postcode}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="country">Country:</label>
            <input
              type="text"
              id="country"
              name="country"
              value={formData.country}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">E-Mail:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password:</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phoneNumber">Phone Number:</label>
            <input
              type="text"
              id="phoneNumber"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="notes">Notes:</label>
            <textarea
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
            />
          </div>
          <button type="submit" className="submit-button">Submit</button>
        </form>
      </div>
    </div>
  );
}

export default CreateCustomer;